import { render, staticRenderFns } from "./MapPOIViewer.vue?vue&type=template&id=f8a2cf36&"
import script from "./MapPOIViewer.vue?vue&type=script&lang=js&"
export * from "./MapPOIViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports